import type {
  AIAssistantQuestionType,
  AICredits,
  AIAssistantConversationListData,
  AIAssistantSelectedDocument,
} from '@/types/ai-assistant'

export type AIAssistantState = {
  questionType: AIAssistantQuestionType | null
  conversationActiveId: string | null
  conversations: AIAssistantConversationListData
  credits: AICredits | null
  creditsPending: boolean
  getConversationsPending: boolean
  getConversationMessagesPending: boolean
  isPaneOpened: boolean
  postPromptPending: boolean
  postPromptStreaming: boolean
  postConversationPending: boolean
  pendingConversationId: string | null
  selectedDocuments: AIAssistantSelectedDocument[]
}

export const state: AIAssistantState = {
  questionType: null,
  conversationActiveId: null,
  conversations: {
    yesterday: [],
    today: [],
    lastSevenDays: [],
    lastThirtyDays: [],
    lastNinetyDays: [],
  },
  credits: null,
  creditsPending: false,
  getConversationsPending: false,
  getConversationMessagesPending: false,
  isPaneOpened: false,
  postPromptPending: false,
  postPromptStreaming: false,
  postConversationPending: false,
  pendingConversationId: null,
  selectedDocuments: [],
}
